/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { CloneTabResponse } from '../model/cloneTabResponse';
// @ts-ignore
import { Tab } from '../model/tab';
// @ts-ignore
import { TabCloneRequest } from '../model/tabCloneRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { WorkspacesAPIConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PublicTabControllerServiceInterface,
    AddTabToPublicWorkspaceRequestParams,
    ClonePublicTabRequestParams,
    DeletePublicTabRequestParams,
    UpdatePublicTabRequestParams
} from './publicTabController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class PublicTabControllerService extends BaseService implements PublicTabControllerServiceInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: WorkspacesAPIConfiguration
    ) {
        super(basePath, configuration);
    }

    /**
     * Add tab to workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTabToPublicWorkspace(
        requestParameters: AddTabToPublicWorkspaceRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Tab>;
    public addTabToPublicWorkspace(
        requestParameters: AddTabToPublicWorkspaceRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Tab>>;
    public addTabToPublicWorkspace(
        requestParameters: AddTabToPublicWorkspaceRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Tab>>;
    public addTabToPublicWorkspace(
        requestParameters: AddTabToPublicWorkspaceRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addTabToPublicWorkspace.');
        }
        const tab = requestParameters?.tab;
        if (tab === null || tab === undefined) {
            throw new Error('Required parameter tab was null or undefined when calling addTabToPublicWorkspace.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Tab>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tab,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Clone tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clonePublicTab(
        requestParameters: ClonePublicTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<CloneTabResponse>;
    public clonePublicTab(
        requestParameters: ClonePublicTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<CloneTabResponse>>;
    public clonePublicTab(
        requestParameters: ClonePublicTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<CloneTabResponse>>;
    public clonePublicTab(
        requestParameters: ClonePublicTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling clonePublicTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling clonePublicTab.');
        }
        const tabCloneRequest = requestParameters?.tabCloneRequest;

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/clone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CloneTabResponse>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tabCloneRequest,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Delete tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePublicTab(
        requestParameters: DeletePublicTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any>;
    public deletePublicTab(
        requestParameters: DeletePublicTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<any>>;
    public deletePublicTab(
        requestParameters: DeletePublicTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<any>>;
    public deletePublicTab(
        requestParameters: DeletePublicTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePublicTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling deletePublicTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Update tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePublicTab(
        requestParameters: UpdatePublicTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Tab>;
    public updatePublicTab(
        requestParameters: UpdatePublicTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Tab>>;
    public updatePublicTab(
        requestParameters: UpdatePublicTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Tab>>;
    public updatePublicTab(
        requestParameters: UpdatePublicTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePublicTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling updatePublicTab.');
        }
        const tab = requestParameters?.tab;
        if (tab === null || tab === undefined) {
            throw new Error('Required parameter tab was null or undefined when calling updatePublicTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Tab>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tab,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }
}
